import { createFileRoute } from "@tanstack/react-router";
import { N8nView } from "@/features/n8n/N8nView";

// X22 N2-N8N-A: the n8n workflow editor, full width under the automations area (the built-in builder stays at /automations).
export const Route = createFileRoute("/_app/automations/n8n")({
  component: () => <N8nView />,
});
